<template>
  <div class="page-index">
    <div class="page-index__body">
      <v-top-hero/>
      <v-top-about/>
      <v-top-brand/>
    </div>
    <v-footer/>
  </div>
</template>



<script>
export default {
  components: {
    'v-footer': require('@/components/footer.vue').default,
    'v-top-hero': require('@/components/top_gogatsu/hero.vue').default,
    // 'v-top-about': require('@/components/top_gogatsu/about.vue').default,
    'v-top-brand': require('@/components/top_gogatsu/brand.vue').default,
  },
}
</script>



<style lang="scss">
.page-index {
  &__body {
    margin-top: 42px;
    margin-bottom: 0;
    @include breakpoints-min(md) {
      margin-top: 0;
      margin-bottom: 128px;
    }
  }
  .top-hero {
    z-index: 1;
  }
  .top-brand {
    z-index: 2;
  }
}
</style>
